import React, { createContext, useContext } from 'react';

const AssistantContext = createContext({
    openAssistant: () => {},
});

export function AssistantProvider({ openAssistant, children }) {
    return (
        <AssistantContext.Provider value={{ openAssistant }}>
            {children}
        </AssistantContext.Provider>
    );
}

export function useAssistant() {
    return useContext(AssistantContext);
}

export default AssistantContext;
